import React, { FC, useCallback, useContext } from 'react'
import Image from 'next/image'
import { ScreenContext } from 'react-components'
import { BannerSlot } from '../../../transports/home-page-transport'
import {
    Section,
    BannerContainer,
    BannerPicture,
    BannerContent,
    BannerHeading,
    BannerDescription,
    BannerButton,
    AdContainer,
    AdSlot,
} from './styles'

type Props = {
    banner: BannerSlot | null
    slotId: string
}

const BannerAdSection: FC<Props> = ({ banner, slotId }) => {
    const { isMobile, isTablet } = useContext(ScreenContext)
    const handleBannerClick = useCallback(() => {
        if (banner?.url) {
            window.open(banner.url, '_blank', 'noopener,noreferrer')
        }
    }, [banner?.url])

    const imageUrl =
        (isMobile && (banner?.image?.mobile?.formats?.medium?.url || banner?.image?.mobile?.url)) ||
        (isTablet && (banner?.image?.tablet?.formats?.medium?.url || banner?.image?.tablet?.url)) ||
        banner?.image?.desktop?.formats?.medium?.url ||
        banner?.image?.desktop?.url

    return (
        <Section>
            {banner && imageUrl && (
                <BannerContainer onClick={handleBannerClick}>
                    <BannerPicture>
                        <Image
                            src={imageUrl}
                            alt={banner.heading || 'Banner'}
                            layout="fill"
                            sizes="(max-width: 1024px) 100vw, 79.75rem"
                        />
                    </BannerPicture>
                    <BannerContent>
                        <BannerHeading $color={banner.color}>{banner.heading}</BannerHeading>
                        {!!banner.description && (
                            <BannerDescription $color={banner.color}>{banner.description}</BannerDescription>
                        )}
                        {!!banner.buttonText && !!banner.url && (
                            <BannerButton onClick={handleBannerClick}>{banner.buttonText}</BannerButton>
                        )}
                    </BannerContent>
                </BannerContainer>
            )}

            <AdContainer>
                <AdSlot id={slotId} />
            </AdContainer>
        </Section>
    )
}

export default BannerAdSection
